import React from 'react';
import { WEB_APP_URL } from '../services/constants';

function SignupPage() {
  return (
    <main className="page-shell signup-shell">
      <section className="signup-card">
        <span className="eyebrow">Web app access</span>
        <h1>Create your account on the web app</h1>
        <p className="signup-text">
          Register and log in at app.talkali.com. The iPhone and Android apps are coming soon.
        </p>

        <div className="signup-highlight">
          <div className="highlight-icon">✓</div>
          <div>
            <strong>Web app is available now</strong>
            <p>
              Use the Talkali web app to register and log in today. Native iPhone and Android apps
              are coming soon.
            </p>
          </div>
        </div>

        <div className="auth-form">
          <a className="primary-button full-width" href="/#apps-section">
            Open Talkali App
          </a>
        </div>

        <div className="qr-grid compact-grid">
          <article className="qr-card">
            <span className="qr-label">iPhone app</span>
            <p className="signup-text">Coming soon</p>
          </article>

          <article className="qr-card">
            <span className="qr-label">Android app</span>
            <p className="signup-text">Coming soon</p>
          </article>
        </div>

        <div className="auth-footer-cta">
          <span>Already have an account?</span>
          <a className="nav-link" href="/#apps-section">
            Open Talkali App
          </a>
        </div>
      </section>
    </main>
  );
}

export default SignupPage;